// Simula dados da blockchain
const tokenData = {
	price: 0.00001234,
	marketCap: 1234567,
	holders: 1234,
	volume24h: 456789,
	priceChange24h: 5.67,
};

// Simula variação de preço baseada em dados reais
const getUpdatedPrice = (currentPrice: number) => {
	const volatility = 0.02; // 2% volatilidade
	const change = currentPrice * volatility * (Math.random() - 0.5);
	return Math.max(0.00000001, currentPrice + change);
};

// Simula token ainda não lançado
const TOKEN_LAUNCHED = false;

// Simula dados iniciais dos power levels
const powerLevelsData = {
	community: {
		current: 8500,
		max: 10000,
		growth: 0,
	},
	meme: {
		current: 9200,
		max: 10000,
		growth: 0,
	},
};

export const api = {
	// Dados do token
	getTokenData: async () => {
		await new Promise((resolve) => setTimeout(resolve, 1000));
		if (!TOKEN_LAUNCHED) {
			throw new Error("Token not launched yet");
		}
		return {
			...tokenData,
			price: getUpdatedPrice(tokenData.price),
		};
	},

	// Dados das missões
	getMissions: async () => {
		await new Promise((resolve) => setTimeout(resolve, 800));
		return [
			{
				id: "volume_mission",
				title: "TRADE LIKE A HERO",
				target: 1000,
				current: Math.floor(Math.random() * 1000),
				icon: "📊",
				reward: "100 POWER POINTS",
			},
			{
				id: "holder_mission",
				title: "HOLD THE LINE",
				target: 24,
				current: Math.floor(Math.random() * 24),
				icon: "⚔️",
				reward: "RARE ACHIEVEMENT",
			},
			{
				id: "social_mission",
				title: "SPREAD THE WORD",
				target: 5,
				current: Math.floor(Math.random() * 5),
				icon: "📢",
				reward: "SOCIAL BADGE",
			},
		];
	},

	// Dados da comunidade
	getCommunityStats: async () => {
		await new Promise((resolve) => setTimeout(resolve, 600));
		return {
			telegramMembers: 1234,
			twitterFollowers: 5678,
			totalTransactions: 9012,
		};
	},

	// Dados do Power Level
	getPowerLevels: async () => {
		await new Promise((resolve) => setTimeout(resolve, 500));

		// Atualiza os valores com alguma variação
		powerLevelsData.community.current = Math.min(
			powerLevelsData.community.max,
			powerLevelsData.community.current + Math.floor(Math.random() * 100)
		);
		powerLevelsData.community.growth = Math.floor(Math.random() * 10);

		powerLevelsData.meme.current = Math.min(
			powerLevelsData.meme.max,
			powerLevelsData.meme.current + Math.floor(Math.random() * 50)
		);
		powerLevelsData.meme.growth = Math.floor(Math.random() * 15);

		return { ...powerLevelsData };
	},

	// Conquistas
	getAchievements: async () => {
		await new Promise((resolve) => setTimeout(resolve, 700));
		return [
			{
				id: "diamond_hands",
				title: "DIAMOND HANDS",
				icon: "💎",
				description: "HODL like a true hero!",
				secret: false,
				unlocked: Math.random() > 0.5,
			},
			{
				id: "community_leader",
				title: "COMMUNITY CHAMPION",
				icon: "👑",
				description: "Lead the Profits Alliance!",
				secret: false,
				unlocked: Math.random() > 0.7,
			},
			{
				id: "ultra_mode",
				title: "ULTRA MUSCLE MODE",
				icon: "⚡",
				description: "You found the secret power!",
				secret: true,
				unlocked: false,
			},
		];
	},
};
